import React from "react";
import {
  Container as MuiContainer,
  ContainerProps as MuiContainerProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

interface ContainerProps extends MuiContainerProps {
  className?: string;
}

const StyledContainer = styled(MuiContainer)<ContainerProps>(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
  },
}));

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (props, ref) => {
    return <StyledContainer ref={ref} maxWidth="xl" {...props} />;
  }
);

Container.displayName = "Container";

export default Container;
